<script>
  import BlockNavigation from '@/components/BlockNavigation/BlockNavigation'
  import Header from '@/components/Header/Header'
  import Notification from '@/components/Notification/Notification'
  import Layer from '@/components/Layer/Layer'
  import List from '@/components/List/List'
  import Simple from '@/components/Simple/Simple'
  import Slider from '@/components/Slider/Slider'
  import Teaser from '@/components/Teaser/Teaser'
  import TeaserSkeleton from '@/components/TeaserSkeleton/TeaserSkeleton'
  import Footer from '@/components/Footer/Footer'
  import { IMAGE_DIMENSIONS } from '@/components/Image/Image'
  import { AdHandler } from '@/services/helper/adHandler'
  import ChannelData from '@/services/builder/Channel'
  import InactivityDialog from '@/services/builder/InactivityDialog'
  import TeaserData from '@/services/builder/Teaser'
  import ViewportData, { VIEWPORT_CHANNEL_NAMES } from '@/services/builder/Viewport'
  import Channel from '@/components/Channel/Channel'
  import { Helper } from '@/services/helper/helper'

  export default {
    name: 'Logout',
    components: {
      'hp-teaser': Teaser,
      'hp-teaser-skeleton': TeaserSkeleton,
      'hp-block-navigation': BlockNavigation,
      'hp-header': Header,
      'hp-notification': Notification,
      'hp-slider': Slider,
      'hp-list': List,
      'hp-simple': Simple,
      'hp-layer': Layer,
      'hp-footer': Footer,
      'hp-channel': Channel
    },
    data () {
      return {
        adHandler: '',
        contentAvailable: false,
        urlParams: new URLSearchParams(window.location.search),
        header: {
          hasRegisterButton: false,
          searchbar: this.$store.state.contentData.searchbar,
          burgerMenu: this.$store.state.contentData.burgerMenu,
          navigation: this.$store.state.contentData.headerNavigations,
          partnerLinks:
            this.$store.state.contentData.headerPartnerLinks?.map((data) => {
              return {
                type: 'hp-ad',
                tagId: data.tagid
              }
            }) || []
        },
        viewport: {},
        channels: [],
        footer: {
          elements: {
            expTeaser:
              this.$store.state.contentData.footer?.separator?.map((data) => {
                return new TeaserData(data, {
                  headerIsDivTag: true,
                  width: 80,
                  height: 80
                })
              }) || [],
            expList:
              this.$store.state.contentData.footer?.linkLists?.map((data) => {
                return {
                  title: data.title,
                  elements: data.elements.map((element) => {
                    return {
                      url: element.url,
                      title: element.title,
                      behaviour: element.behaviour,
                      external: element.external
                    }
                  })
                }
              }) || [],
            sharedExternalLinks:
              this.$store.state.contentData.footer?.sharedExternalLinks?.map((data) => {
                return {
                  type: 'hp-ad',
                  tagId: data.tagid,
                  autoLoad: false
                }
              }) || [],
            expImg:
              this.$store.state.contentData.footer?.additionLinks?.map((data) => {
                return {
                  url: data.url,
                  title: '',
                  behaviour: data.behaviour,
                  external: data.external,
                  image: {
                    alt: data.image.altText,
                    isCoreMedia: data.image.coreMediaImage,
                    lazy: data.image.lazyLoading,
                    url: data.image.url,
                    width: IMAGE_DIMENSIONS.award.width,
                    height: IMAGE_DIMENSIONS.award.height
                  }
                }
              }) || [],
            expLink:
              this.$store.state.contentData.footer?.legalLinks?.map((data) => {
                return {
                  url: data.url,
                  title: data.title,
                  behaviour: data.behaviour,
                  external: data.external
                }
              }) || []
          }
        },
        notifications: {
          top:
            this.$store.state.contentData.notifications?.filter((notification) => {
              return notification.position === 'top'
            }) || [],
          afterHeader:
            this.$store.state.contentData.notifications?.filter((notification) => {
              return notification.position === 'afterHeader'
            }) || [],
          beforeLogin:
            this.$store.state.contentData.notifications?.filter((notification) => {
              return notification.position === 'beforeLogin'
            }) || []
        },
        inactivityDialog: this.$store.state.contentData.inactivityDialog ? new InactivityDialog(this.$store.state.contentData.inactivityDialog) : null,
        teaserSkeleton: {
          fixedTypes: {
            1: 'big'
          }
        }
      }
    },
    async mounted () {
      const _this = this
      document.querySelector('html').classList.remove('ce-available')

      document.addEventListener('channelsAvailable', () => {
        if (_this.adHandler.selectedAd !== 'maxiad') {
          _this.viewport = new ViewportData({
            channelData: _this.$store.state.contentData.channels?.filter((channel) => channel.meta.name === VIEWPORT_CHANNEL_NAMES[0])?.[0],
            adLayout: _this.$store.state.contentData.adLayout
          })
          _this.channels = _this.$store.state.contentData.channels?.filter((channel) => VIEWPORT_CHANNEL_NAMES.indexOf(channel.meta.name) === -1).map((data) => new ChannelData(data))
        } else {
          _this.$store.commit('setChannelsRendered', true)
          _this.$store.commit('setPageVisible', true)
        }
        _this.inactivityDialog = _this.$store.state.contentData.inactivityDialog ? new InactivityDialog(_this.$store.state.contentData.inactivityDialog) : _this.inactivityDialog
        _this.contentAvailable = true
      })

      this.adHandler = new AdHandler(this)

      this.adHandler.makePrioAd()
    },
    updated () {
      this.$nextTick(() => {
        this.contentAvailable && this.$store.commit('setChannelsRendered', true)
        this.contentAvailable && this.$store.state.pageReady && this.$store.commit('setPageVisible', true)
        Helper.fireEvent('DOMChanged')

        const searchbar = document.querySelector('[data-component=searchbar] input[data-type=search]')
        searchbar && searchbar.focus()
      })
    }
  }
</script>

<template src="./Logout.html"></template>
